import * as Yup from "yup"
import {
	ssnRegex,
	usCountryCodeRegex,
	intlCountryCodeRegex,
	usPhoneNumberRegex,
	intlPhoneNumberRegex,
} from "../../../../utilities/validation"
import {CA_COUNTRY_CODE, caPostalCode, US_COUNTRY_CODE, usPostalCode} from "../../../../resources/address"
import {
	address,
	dateOfBirth,
	email,
	fullName,
	matriculaConsular,
	nationality,
	passport,
	phone,
	ssn,
} from "../../../../utilities/validation"

const validationErrorMessages = {
	fullName: fullName,
	ssn: ssn,
	nationality: nationality,
	passport: passport,
	matriculaConsular: matriculaConsular,
	address: address,
	dateOfBirth: dateOfBirth,
	phone: phone,
	email: email,
	percentage: {
		invalid: "The percentage you have provided is invalid",
	},
}

export default {
	fullName: Yup.object({
		first: Yup.string().required(validationErrorMessages.fullName.first.required),
		last: Yup.string().required(validationErrorMessages.fullName.last.required),
	}),
	ssn: Yup.string().when("identificationType", {
		is: "ssn",
		then: Yup.string()
			.required(validationErrorMessages.ssn.required)
			.matches(ssnRegex, validationErrorMessages.ssn.invalid),
	}),
	nationality: Yup.string().when("identificationType", {
		is: "passport",
		then: Yup.string().required(validationErrorMessages.nationality.required),
	}),
	passport: Yup.string().when("identificationType", {
		is: "passport",
		then: Yup.string().required(validationErrorMessages.passport.required),
	}),
	matriculaConsular: Yup.string().when("identificationType", {
		is: "matriculaConsular",
		then: Yup.string().required(validationErrorMessages.matriculaConsular.required),
	}),
	address: Yup.object({
		street: Yup.string().required(validationErrorMessages.address.street.required),
		city: Yup.string().required(validationErrorMessages.address.city.required),
		state: Yup.string().when("country", {
			is: (country: string) => [US_COUNTRY_CODE, CA_COUNTRY_CODE].includes(country),
			then: Yup.string().required(validationErrorMessages.address.state.required),
		}),
		postalCode: Yup.string()
			.required(validationErrorMessages.address.postalCode.required)
			.when("country", {
				is: US_COUNTRY_CODE,
				then: Yup.string().matches(usPostalCode, validationErrorMessages.address.postalCode.usInvalid),
			})
			.when("country", {
				is: CA_COUNTRY_CODE,
				then: Yup.string().matches(caPostalCode, validationErrorMessages.address.postalCode.caInvalid),
			}),
		country: Yup.string().required(validationErrorMessages.address.country.required),
	}),

	dateOfBirth: Yup.date()
		.required(validationErrorMessages.dateOfBirth.required)
		.max(new Date(), validationErrorMessages.dateOfBirth.max),
	identificationType: Yup.string().oneOf(["ssn", "passport", "matriculaConsular"]),
	phone: Yup.object({
		countryCode: Yup.string()
			.required(validationErrorMessages.phone.countryCode.required)
			.matches(
				new RegExp(`${usCountryCodeRegex.source}|${intlCountryCodeRegex.source}`),
				validationErrorMessages.phone.countryCode.required
			),
		number: Yup.string()
			.required(validationErrorMessages.phone.number.required)
			.when("countryCode", {
				is: (value: string) => usCountryCodeRegex.test(value),
				then: Yup.string().matches(usPhoneNumberRegex, validationErrorMessages.phone.number.usInvalid),
			})
			.when("countryCode", {
				is: (value: string) => intlCountryCodeRegex.test(value),
				then: Yup.string().matches(intlPhoneNumberRegex, validationErrorMessages.phone.number.intlInvalid),
			}),
	}),
	percentage: Yup.number().min(1).max(100),
	email: Yup.string().email(validationErrorMessages.email.invalid).required(validationErrorMessages.email.required),
}
